export enum CollectionTitles {
	Skvllpvnkz = 'Skvllpvnkz',
	Skvllbabiez = 'Skvllbabiez',
}
